import React from 'react'
import Ers from '../svg/Ers'

export default function Footer() {
  return (
    <footer className="footer">
      <p>
        <Ers />
        Verified by ers
      </p>
    </footer>
  )
}
